import { Input } from "@/components/ui/input";
import { SearchIcon } from "lucide-react";
import FilterMenu from "../../filter/FilterMenu";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import parseUrlToQueryParams from "@/v2/utils/parseUrlToQueryParams";
import { FilterColumn } from "../../filter";
import ExportButton from "../../ui/button/general/Export";
import { useDebounce } from "use-debounce";

export function TableToolbar<T>({
    column,
    searchPlaceHolder,
    exportFileName,
    exportFunc,
    disableFilter = false,
}: {
    column: FilterColumn<T>[];
    searchPlaceHolder?: string;
    exportFileName?: string;
    exportFunc?: () => Promise<any>;
    disableFilter?: boolean;
}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const [searchTerm, setSearchTerm] = useState(queryParams?.search);
    const [debouncedSearchTerm] = useDebounce(searchTerm, 1000);

    useEffect(() => {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            if (debouncedSearchTerm) {
                params.set("search", debouncedSearchTerm);
                params.delete("skip");
            } else {
                params.delete("search");
            }
            return params;
        });
    }, [debouncedSearchTerm]);

    return (
        <div className="flex items-center justify-between gap-2 py-2">
            <div className="flex w-1/3 items-center justify-start rounded-xl border border-gray-200 focus-within:ring-1 focus-within:ring-primary">
                <SearchIcon className="ml-2 h-4 w-4 text-gray-400" />

                <Input
                    className="w-full border-0 focus-visible:ring-0 focus-visible:ring-offset-0"
                    placeholder={searchPlaceHolder || "Search ..."}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <div className="flex items-center justify-between gap-2">
                {exportFunc && exportFileName && (
                    <ExportButton
                        onExport={exportFunc}
                        fileName={exportFileName}
                    />
                )}

                <FilterMenu<T> columns={column} disableFilter={disableFilter} />
            </div>
        </div>
    );
}
